import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    getTableList: {
        url: `${profileApi}/api/business_moments/rank`,
        type: 'GET',
    },

    // 导出
    exportData: {
        url: `${profileApi}/api/business_moments/rank/export`,
        type: 'GET',
    },
}
